import React from 'react'
import '../assets/css/etapas.css'

// Indicador de etapas de um cadastro em passos (1 — 2 — ...).
// Etapas já concluídas ficam marcadas e, com aoClicar, permitem voltar a elas.
const Etapas = ({ etapas, atual, aoClicar }) => (
    <div className='etapas'>
        {etapas.map((titulo, i) => {
            const concluida = i < atual
            const clicavel = concluida && !!aoClicar

            return <React.Fragment key={titulo}>
                {i > 0 && <div className={'etapas-linha' + (i <= atual ? ' etapas-linha-ativa' : '')} />}
                <div className={'etapas-item' + (i === atual ? ' etapas-atual' : '') + (concluida ? ' etapas-concluida' : '') + (clicavel ? ' etapas-clicavel' : '')}
                    onClick={clicavel ? () => aoClicar(i) : undefined}>
                    <div className='etapas-circulo'>{concluida ? <span className='icon-Yes' /> : i + 1}</div>
                    <div className='etapas-titulo'>{titulo}</div>
                </div>
            </React.Fragment>
        })}
    </div>
)

export default Etapas
